import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { fullNamePresenter } from 'utils';

const Physician = ({ doctor, clinic }) => (
  <>
    <h5>Physician Information</h5>
    <Table
      className="patient-doctor-info"
      borderless
      border="0"
      cellSpacing="0"
      cellPadding="0"
    >
      <thead>
        <tr>
          <th>
            <div className="pagination-container">
              <h5>Physician</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Details</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Doctor</td>
          <td>
            <span>
              {fullNamePresenter({
                title: doctor.title,
                firstName: doctor.firstName,
                lastName: doctor.lastName,
              })}
            </span>
            <span>{doctor?.professionType}</span>
            {doctor.status === 'inactive' && (
              <span className="error-message">
                *the doctor is currently inactive
              </span>
            )}
          </td>
        </tr>
        <tr>
          <td>Clinic</td>
          <td>
            {clinic?.legalname && (
              <>
                <span className="subheader">Legal Name:</span>
                <span>{clinic?.legalname}</span>
              </>
            )}
            {clinic?.email && (
              <>
                <span className="subheader">Email:</span>
                <span className="text-transform-none">{clinic?.email}</span>
              </>
            )}
            {clinic?.phone && (
              <>
                <span className="subheader">Phone Number:</span>
                <span>{clinic?.phone}</span>
              </>
            )}
            {clinic?.fax && (
              <>
                <span className="subheader">Fax:</span>
                <span>{clinic?.fax}</span>
              </>
            )}
            {(clinic?.addressLine1 || clinic?.addressLine2) && (
              <>
                <span className="subheader">Addresses:</span>
                <span>
                  {clinic?.addressLine1} {clinic?.addressLine2}
                </span>
              </>
            )}
            {clinic?.city && (
              <>
                <span className="subheader">City:</span>
                <span>{clinic?.city}</span>
              </>
            )}
            {clinic?.state && (
              <>
                <span className="subheader">State:</span>
                <span>{clinic?.state}</span>
              </>
            )}
            {clinic?.zip && (
              <>
                <span className="subheader">Zip:</span>
                <span>{clinic?.zip}</span>
              </>
            )}
            {clinic.status === 'inactive' && (
              <span className="error-message">
                *the clinic is currently inactive
              </span>
            )}
          </td>
        </tr>
      </tbody>
    </Table>
  </>
);

Physician.propTypes = {
  doctor: PropTypes.shape().isRequired,
  clinic: PropTypes.shape().isRequired,
};

export default Physician;
